import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuilderPublished = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Unpublished",
	xmlns: "http://www.w3.org/2000/svg",
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		id: "Ellipse_753",
		"data-name": "Ellipse 753",
		cx: 28,
		cy: 28,
		r: 28,
		fill: "none"
	}), /* @__PURE__ */ _jsxs("g", {
		id: "White",
		transform: "translate(12 12)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Icon_Post_24px",
			"data-name": "Icon/Post/24px",
			d: "M6.747,25.035c6.63-7.206,11.655-8.211,11.655-8.211a9.392,9.392,0,0,1-1.145,2.464c-.8,1.183-1.222.719-2.042,2.27a13.608,13.608,0,0,1,2.417-.174c-1.361,2.077-4.822,4.04-5.433,4.482a15,15,0,0,0,2.442,0A8.417,8.417,0,0,1,12.2,28.511a4.929,4.929,0,0,1-2.794.52s-1.343-.512-3.091,1.79c-3.982,5.244-3.84,6.98-3.84,6.98l-1.432.946S.117,32.241,6.747,25.035Z",
			transform: "translate(6.002 -11.824)"
		}), /* @__PURE__ */ _jsx("rect", {
			id: "BoundingBox",
			width: 32,
			height: 32,
			fill: "rgba(255,255,255,0)"
		})]
	})]
});
export default SvgBuilderPublished;
